export default __webpack_public_path__ + "static/media/Header_logo1.815396f7.png";